export const companyAddress = {
  address1: 'ul. Hausbrandta 32/37',
  address2: '80-126 Gdańsk, Poland',
  tel: '+48 664 023 815',
  companyMail: 'contact@thegoodcode.io'
}

export const careerSteps = [
  {
    id: '01',
    title: 'Getting to know each other',
    description:
      'After receiving  your application we will  contact you to arrange  an orientation talk with our HR Team.'
  },
  {
    id: '02',
    title: 'Technical assignment',
    description:
      'To help us to assess your technical skills, we will give you a short, assignment to do in your own work environment and time.'
  },
  {
    id: '03',
    title: 'Meet the technical leader',
    description:
      'During our 2nd interview  you will meet our Technical Leader for a  technical skills evaluation and chat about your technical background and past experience.  '
  },
  {
    id: '04',
    title: 'Preparation for your new role',
    description:
      'After successful Technical Interview we will start the preparation process for your new job.'
  },
  {
    id: '05',
    title: 'Starting collaboration',
    description: 'Your professional journey with the.good.code; starts here !'
  }
]

export const ourCommitmentContent = [
  {
    title: 'We are colleagues',
    desc: 'We consider each candidate as future colleague.'
  },
  {
    title: 'Growth',
    desc: 'You are set for success in team of experts, supporting you and giving the right feedback to contribute to your professional growth.'
  },
  {
    title: 'Equality and diversity',
    desc: 'At the.good.code believe, equality and diversity in the workplace is essential for creating a positive and inclusive work environment, where all employees can thrive and reach their full potential. '
  },
  {
    title: 'Support',
    desc: 'We want to make sure you are supported and understand the decision taken at each step of the recruitment process.'
  },
  {
    title: 'Right opportunities',
    desc: 'We help candidates make an informed choice.'
  },
  {
    title: 'Our goal',
    desc: 'Is to be transparent, collaborative and to enable each team member for success while walking with us the path of continuous growth.'
  }
]
